import { createFileRoute } from "@tanstack/react-router";
import { VilkårPage } from "@/features/landing/VilkårPage";

export const Route = createFileRoute("/_landing/vilkår")({
  component: VilkårPage,
  head: () => ({
    meta: [
      {
        title: "Vilkår | Norgespris for Fjernvarme",
      },
    ],
  }),
});
